import classNames from "classnames";
import { Link } from "~/common/components/Link";
import type { CMSLinkProps } from "~/features/cms/types/props";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export const CMSLink = (props: CMSLinkProps) => {
  const { url, label, target, className } = props;
  return (
    <Link
      className={classNames("scha__cms scha__cmssection__sub--link", className)}
      href={url}
      target={target}
      iconBefore={<KeyboardArrowRightIcon className={"scha__link--arrow-link"}  />}
    >
      {label}
    </Link>
  );
};
